"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.participantRole = exports.ParticipantRoles = void 0;
const typegate_1 = require("typegate");
exports.ParticipantRoles = {
    INSURED: 'INSURED',
    OWNER_PERSON: 'OWNER_PERSON',
    LEGAL_GUARDIAN: 'LEGAL_GUARDIAN',
    PAYER: 'PAYER',
    SECONDARY_PAYER: 'SECONDARY_PAYER',
    OWNER_ORGANIZATION: 'OWNER_ORGANIZATION',
    PRIMARY_BENEFICIARY: 'PRIMARY_BENEFICIARY',
    CONTINGENT_BENEFICIARY: 'CONTINGENT_BENEFICIARY',
    AGENT: 'AGENT',
    TRANSLATOR: 'TRANSLATOR',
    SIGNING_AUTHORITY: 'SIGNING_AUTHORITY',
    TRUSTEE: 'TRUSTEE',
    SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
    OFFICER: 'OFFICER',
    ANNUITANT: 'ANNUITANT',
    CONTRIBUTOR: 'CONTRIBUTOR',
    SECONDARY_CONTRIBUTOR: 'SECONDARY_CONTRIBUTOR',
};
exports.participantRole = typegate_1.t.union(typegate_1.t.literal('INSURED'), typegate_1.t.literal('OWNER_PERSON'), typegate_1.t.literal('LEGAL_GUARDIAN'), typegate_1.t.literal('PAYER'), typegate_1.t.literal('SECONDARY_PAYER'), typegate_1.t.literal('OWNER_ORGANIZATION'), typegate_1.t.literal('PRIMARY_BENEFICIARY'), typegate_1.t.literal('CONTINGENT_BENEFICIARY'), typegate_1.t.literal('AGENT'), typegate_1.t.literal('TRANSLATOR'), typegate_1.t.literal('SIGNING_AUTHORITY'), typegate_1.t.literal('TRUSTEE'), typegate_1.t.literal('SOLE_PROPRIETOR'), typegate_1.t.literal('OFFICER'), typegate_1.t.literal('ANNUITANT'), typegate_1.t.literal('CONTRIBUTOR'), typegate_1.t.literal('SECONDARY_CONTRIBUTOR'));
